import { colors } from "@/utils/const";
import Box from "@mui/material/Box";
import CustomText from "./text";

export default function CenterTitle({
  title,
  subtitle,
  withBg,
  color,
  title_variant,
  subtitle_variant,
}) {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", md: "70%", lg: "50%" },
        margin: "auto",
        textAlign: "center",
      }}
    >
      {title && (
        <CustomText
          text={title}
          type="xxl"
          customStyle={{
            color: withBg
              ? colors.yellow
              : color
                ? color || colors.dark_yellow
                : colors.orange,
            fontWeight: "700",
            mb: 1,
            lineHeight: 1,
          }}
          variant={title_variant || "h2"}
        />
      )}

      {subtitle && (
        <CustomText
          text={subtitle}
          type="xs"
          customStyle={{ mb: 4, color: withBg ? "#fff" : "#000" }}
          variant={subtitle_variant || "body1"}
        />
      )}
    </Box>
  );
}
